<template>
  <div xstyle="display:block;height:48px;width:280px;z-index:1000">
    <template v-if="isMobileDevice()">
      <s-action-pannel @click="modalDater=true">
        <el-button slot="actions" type="text">
          <i class="material-icons">date_range</i>
        </el-button>

        <span>{{displayContent}}</span>
      </s-action-pannel>
      <!-- <el-button @click="modalDater=true" style="width:100%">{{displayContent}}</el-button> -->
      <!-- <el-dialog
        :visible.sync="modalDater"
        :destroy-on-close="true"
        :modal="false"
        center
        :show-close="false"
        :modal-append-to-body="false"
        :append-to-body="true"
        :fullscreen="true"
      >-->
      <div class="myMobModal" v-if="modalDater">
        <el-row>
          <el-button
            style="float:right"
            type="text"
            icon="el-icon-close"
            circle
            @click="modalDater = false"
          ></el-button>
        </el-row>
        <el-row>
          <VueCtkDateTimePicker
            style="height:48px;position: fixed;width:280px;z-index:1000"
            :range="range"
            :formatted="elDisplayFormat"
            :only-date="!withTime"
            v-model="content"
            auto-close
            dark
            inline
            :custom-shortcuts="processedShortcuts"
          />
        </el-row>
        <el-button @click="content=null;modalDater=false" style="width:100%">.Τα παντα</el-button>
      </div>
      <!-- </el-dialog> -->
    </template>
    <VueCtkDateTimePicker
      v-else
      dark
      :range="range"
      :formatted="elDisplayFormat"
      :only-date="!withTime"
      v-model="content"
      :auto-close="!range"
      :custom-shortcuts="processedShortcuts"
    />
  </div>
</template>

<script>
// pattern="^([0]?[1-9]|[1|2][0-9]|[3][0|1])/([0]?[1-9]|[1][0-2])/(19|20)\d\d$"
import * as moment from "moment";
export default {
  name: "sr-ctk-dater",
  data() {
    return {
      content: null,
      dateOne: "",
      dateTwo: "",
      modalDater: false,
    };
  },
  props: {
    routeQueryProp: { type: String, default: null },
    startPlaceholder: { type: String, default: "from" },
    toPlaceholder: { type: String, default: "to" },
    default: { type: String, default: null },
    value: { default: null },
    displayFormat: {
      default: "DD/MM/YYYY", //
    },
    customiseShortcuts: {
      type: Array,
      default: () => null,
    },
    shortcuts: {
      type: Array,
      default: () => [
        { key: "lastWeek", label: "Last week", value: "-isoWeek" },
        { key: "thisWeek", label: "This week", value: "isoWeek" },
        {
          key: "nextWeek",
          label: "Next Week",
          value: () => {
            return {
              start: moment().add(1, "week").startOf("week"),
              end: moment().add(1, "week").endOf("week"),
            };
          },
        },
        // { key: "last7Days", label: "Last 7 days", value: 7 },
        // { key: "last30Days", label: "Last 30 days", value: 30 },

        { key: "lastMonth", label: "Last month", value: "-month" },
        { key: "thisMonth", label: "This month", value: "month" },
        {
          key: "nextMonth",
          label: "Next Month",
          value: () => {
            return {
              start: moment().add(1, "month").startOf("month"),
              end: moment().add(1, "month").endOf("month"),
            };
          },
        },
        { key: "lastYear", label: "Last year", value: "-year" },
        { key: "thisYear", label: "This year", value: "year" },

        {
          key: "nextYear",
          label: "Next year",
          value: () => {
            return {
              start: moment().add(1, "year").startOf("year"),
              end: moment().add(1, "year").endOf("year"),
            };
          },
        },
      ],
    },
    placeholder: { type: String, default: "DD/MM/YYYY" },
    type: { type: String, default: "date" },
    range: { type: Boolean, default: false },
    // withTime: { type: Boolean, default: false },
    exportFormat: {
      default: "unxtimestamp",
    },
    valueFormat: {
      default: "unxtimestamp",
    },
  },
  computed: {
    displayContent() {
      var out = "";
      if (!this.content) return "απο παντα εως παντα";
      if (this.content && this.content.start) {
        out = moment(this.content.start, "YYYY-MM-DD hh:mm a").format(
          "DD/MM/YYYY"
        );
      }
      if (this.content && this.content.end) {
        out +=
          "-" +
          moment(this.content.end, "YYYY-MM-DD hh:mm a").format("DD/MM/YYYY");
      }

      return out;
    },
    processedShortcuts() {
      var out = [],
        vm = this;
      if (!this.customiseShortcuts) return this.shortcuts;
      this.customiseShortcuts.forEach((sc) => {
        var existed = vm.findInArray(vm.shortcuts, { key: sc.key });
        if (existed) {
          if (sc.label) existed.label = sc.label;
          if (sc.value) existed.value = sc.value;
        } else {
          if (sc.key && sc.value && sc.label) existed = sc;
          else console.error("Skiiping...Cant add shortcut configuration ", sc);
        }
        if (existed) out.push(existed);
      });
      // _log_("out...", out);
      return out;
    },
    withTime() {
      return this.type != "date";
    },
    elDisplayFormat() {
      if (this.displayFormat.indexOf("/") >= 0) {
        if (this.type == "datetime") return "YYYY-MM-DD hh:mm a";
        return "DD/MM/YYYY";
      }
      return "X";
    },
    elExportFormat() {
      // return "DD/MM/YYYY";
      if (this.exportFormat.indexOf("/") >= 0) {
        if (this.type == "datetime") return "YYYY-MM-DD hh:mm a";
        return "DD/MM/YYYY";
      }
      return "YYYY-MM-DD hh:mm a";
      // _log_("hel.ww..form..", this.valueFormat);
      // if (this.valueFormat == "auto")
      //   return (this.value + "").indexOf("/") > 0
      //     ? "dd/MM/yyyy"
      //     : "unxtimestamp";
      // return this.valueFormat == "unxtimestamp"
      //   ? "timestamp"
      //   : this.valueFormat;
    },
    pickerOptions() {
      var vm = this;
      return {};
    },
  },
  watch: {
    dateOne(value, ov) {
      _log_("hel.DATE.Pa.", value);
    },
    value: {
      handler(value, ov) {
        if (value && value != ov) {
          _log_("hel.ww.PVV.", value, ov);
          return;
          if (!this.value && !this.default == "thisyear") {
            if (!this.range) return null;
            this.content = {
              start: moment().startOf("year"),
              end: moment().endOf("year"),
            };
            this.$emit("change", [
              moment(this.content.start, "YYYY-MM-DD hh:mm a").format(mf),
              moment(this.content.end, "YYYY-MM-DD hh:mm a").format(mf),
            ]);
            this.$emit("input", [
              moment(this.content.start, "YYYY-MM-DD hh:mm a").format(mf),
              moment(this.content.end, "YYYY-MM-DD hh:mm a").format(mf),
            ]);
            return;
          }
          if (!this.range) {
            if (this.valueFormat == "unxtimestamp")
              this.content = moment
                .unix(this.value)
                .format("YYYY-MM-DD hh:mm a");
            else
              this.content = moment(this.value, "DD/MM/YYYY").format(
                "YYYY-MM-DD hh:mm a"
              );
          } else {
            if (_.isArray(this.value) && !this.value.length) {
              this.content = {
                start: moment().startOf("year"),
                end: moment().endOf("year"),
              };
              this.$emit("input", [
                moment(this.content.start, "YYYY-MM-DD hh:mm a").format(mf),
                moment(this.content.end, "YYYY-MM-DD hh:mm a").format(mf),
              ]);
              this.$emit("change", [
                moment(this.content.start, "YYYY-MM-DD hh:mm a").format(mf),
                moment(this.content.end, "YYYY-MM-DD hh:mm a").format(mf),
              ]);
            } else
              this.content =
                this.value && this.valueFormat == "unxtimestamp"
                  ? { start: this.value[0] * 1000, end: this.value[1] * 1000 }
                  : this.value;
          }
        }
      },
      immediate: true,
    },

    content(value, oldVal) {
      _log_("renamge===,", value, oldVal);
      const mf = this.exportFormat.indexOf("/") >= 0 ? "DD/MM/YYYY" : "X";
      if (!value && !oldVal) return;

      if (value != oldVal) {
        if (this.range) {
          if (!value || (_.isArray(value) && !value.length)) {
            //|| isNaN(value.end) || isNaN(value.start)) {
            if (this.routeQueryProp) {
              let q = _.clone(this.$route.query);
              if (q[this.routeQueryProp + "_from"])
                delete q[this.routeQueryProp + "_from"];
              if (q[this.routeQueryProp + "_to"])
                delete q[this.routeQueryProp + "_to"];
              _log_("hRR.1");
              this.routeGo({ query: q }); // name: "timelineForProducts",
            }
            this.$emit("change", [null, null]);
            this.$emit("input", [null, null]);
            return;
          }

          this.$emit("change", [
            isNaN(value.start)
              ? null
              : moment(value.start, "YYYY-MM-DD hh:mm a").format(mf),
            isNaN(value.end)
              ? null
              : moment(value.end, "YYYY-MM-DD hh:mm a").format(mf),
          ]);
          this.$emit("input", [
            isNaN(value.start)
              ? null
              : moment(value.start, "YYYY-MM-DD hh:mm a").format(mf),
            isNaN(value.end)
              ? null
              : moment(value.end, "YYYY-MM-DD hh:mm a").format(mf),
          ]);

          this.reportToRoute();
        } else {
          if (!value) {
            this.$emit("change", null);
            this.$emit("input", null);
            this.reportToRoute();
            return;
          }
          this.$emit("change", moment(value, "YYYY-MM-DD hh:mm a").format(mf));
          this.$emit("input", moment(value, "YYYY-MM-DD hh:mm a").format(mf));
          this.reportToRoute();
        }
      }
    },
  },
  created() {
    const mf = this.exportFormat.indexOf("/") >= 0 ? "DD/MM/YYYY" : "X";
    // if (this.range) this.content = [];
    if (this.routeQueryProp) {
      if (
        this.$route.query[this.routeQueryProp + "_to"] &&
        this.$route.query[this.routeQueryProp + "_from"]
      ) {
        this.content = {};
        this.content.start = moment(
          this.$route.query[this.routeQueryProp + "_from"],
          mf
        ).format("YYYY-MM-DD hh:mm a");
        this.content.end = moment(
          this.$route.query[this.routeQueryProp + "_to"],
          mf
        ).format("YYYY-MM-DD hh:mm a");
      }
    }
    // if (!this.value && !this.default == "thisyear") {
    //   if (!this.range) return null;
    //   this.content = {
    //     start: moment().startOf("year"),
    //     end: moment().endOf("year")
    //   };
    //   this.$emit("change", [
    //     moment(this.content.start, "YYYY-MM-DD hh:mm a").format(mf),
    //     moment(this.content.end, "YYYY-MM-DD hh:mm a").format(mf)
    //   ]);
    //   this.$emit("input", [
    //     moment(this.content.start, "YYYY-MM-DD hh:mm a").format(mf),
    //     moment(this.content.end, "YYYY-MM-DD hh:mm a").format(mf)
    //   ]);
    //   return;
    // }
    // if (!this.range) {
    //   if (this.valueFormat == "unxtimestamp")
    //     this.content = moment.unix(this.value).format("YYYY-MM-DD hh:mm a");
    //   else
    //     this.content = moment(this.value, "DD/MM/YYYY").format(
    //       "YYYY-MM-DD hh:mm a"
    //     );
    // } else {
    //   if (_.isArray(this.value) && !this.value.length) {
    //     this.content = {
    //       start: moment().startOf("year"),
    //       end: moment().endOf("year")
    //     };
    //     this.$emit("input", [
    //       moment(this.content.start, "YYYY-MM-DD hh:mm a").format(mf),
    //       moment(this.content.end, "YYYY-MM-DD hh:mm a").format(mf)
    //     ]);
    //     this.$emit("change", [
    //       moment(this.content.start, "YYYY-MM-DD hh:mm a").format(mf),
    //       moment(this.content.end, "YYYY-MM-DD hh:mm a").format(mf)
    //     ]);
    //   } else
    //     this.content =
    //       this.value && this.valueFormat == "unxtimestamp"
    //         ? { start: this.value[0] * 1000, end: this.value[1] * 1000 }
    //         : this.value;
    // }
    // this.content = [date.getTime(), date.getTime()];
  },
  methods: {
    reportToRoute() {
      _log_("hel.ww.RRRR.", this.routeQueryProp, this.content);
      if (this.routeQueryProp && this.content.start && this.content.end) {
        const mf = this.exportFormat.indexOf("/") >= 0 ? "DD/MM/YYYY" : "X";
        var range = [];
        let q = _.clone(this.$route.query);
        if (this.content.start)
          q[this.routeQueryProp + "_from"] = moment(
            this.content.start,
            "YYYY-MM-DD hh:mm a"
          ).format(mf);
        else delete q[this.routeQueryProp + "_from"];
        if (this.content.end)
          q[this.routeQueryProp + "_to"] = moment(
            this.content.end,
            "YYYY-MM-DD hh:mm a"
          ).format(mf);
        else delete q[this.routeQueryProp + "_to"];
        // _log_("hel.ww.RRR22R.", q, this.$route.query);
        if (
          q[this.routeQueryProp + "_to"] ==
            this.$route.query[this.routeQueryProp + "_to"] &&
          q[this.routeQueryProp + "_from"] ==
            this.$route.query[this.routeQueryProp + "_from"]
        )
          return;
        this.$route.query[this.routeQueryProp];
        this.routeGo({ query: q }); //name: "timelineForProducts",
      }
    },
    setRange(a, b) {
      if (a) this.content = { end: this.content.end, start: a };
      if (b) this.content = { start: this.content.start, end: b };
      _log_("date..", a, b);
    },
    updateModel(val) {
      this.$emit("change", [val.start, val.end]);
      this.$emit("input", [val.start, val.end]);
    },
    init() {},
  },
};
</script>
<style>
div.myMobModal {
  position: fixed;
  top: 0px;
  left: 0px;
  height: 100vh;
  width: 100vw;
  z-index: 5000;
  background-color: aquamarine;
}
.el-range-editor--medium.el-input__inner {
  height: 42px;
}
div.date-time-picker div input {
  background-color: transparent !important;
  color: whitesmoke !important;
}
div.date-time-picker div label {
  background-color: transparent !important;
  color: wheat !important;
}
.datepicker-button-effect,
.custom-button-effect,
.datepicker-day-effect,
.header-picker {
  background: #095b69 !important;
}
.datepicker-button,
.custom-button,
.datepicker-buttons-container,
.pickers-container {
  background: #009688 !important;
}
.custom-button-content {
  color: #ffffff !important;
}
.datepicker-buttons-container .datepicker-button {
  background: #077083 !important;
  border: none !important;
}
.datepicker-buttons-container .datepicker-button svg {
  fill: #ffffff !important;
}
label.field-label {
  background-color: transparent !important;
  color: whitesmoke !important;
}
</style>
